import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { User, ProfileValue, PasswordValue } from '../models';

export const profileActions = createActionGroup({
    source: 'Profile',
    events: {
        // Get
        'Get Profile': emptyProps(),
        'Get Profile Success': props<{ payload: User }>(),
        'Get Profile Error': props<{ code: number }>(),
        // Update
        'Update Profile': props<{ value: ProfileValue }>(),
        'Update Profile Success': props<{ payload: User }>(),
        'Update Profile Error': props<{ code: number }>(),
        // Change Password
        'Change Password': props<{ value: PasswordValue }>(),
        'Change Password Success': emptyProps(),
        'Change Password Error': props<{ code: number }>(),
        // Clear
        Clear: emptyProps(),
    },
});
